import { MedplumClient } from "@medplum/core";

export async function nextGenComapabilitr4(medplum: MedplumClient, payload: any) {
  try {
    const res = await medplum.executeBot(
      {
        system: "https://api-stage.healthconnect.systems/bots",
        value: "nextGen-capability-r4",
      },
      payload
    );
    return res;
  } catch (err) {
    console.error("Unexpected error:", err);
  }
}
export async function nextGenComapabilitdstu2(
  medplum: MedplumClient,
  payload: any
) {
  try {
    const res = await medplum.executeBot(
      {
        system: "https://api-stage.healthconnect.systems/bots",
        value: "nextGen-capability-dstu2",
      },
      payload
    );
    return res;
  } catch (err) {
    console.error("Unexpected error:", err);
  }
}

export async function athenaOneComapabilitr4(medplum: MedplumClient, payload: any) {
  try {
    const res = await medplum.executeBot(
      {
        system: "https://api-stage.healthconnect.systems/bots",
        value: "athenaOne-capability-r4",
      },
      payload
    );
    return res;
  } catch (err) {
    console.error("Unexpected error:", err);
  }
}
export async function veradigmComapabilitr4(medplum: MedplumClient, payload: any) {
  try {
    console.log('herrrrrrrrrrrre2')
    const res = await medplum.executeBot(
      {
        system: "https://api-stage.healthconnect.systems/bots",
        value: "veradigm-capability-r4",
      },
      payload
    );
    return res;
  } catch (err) {
    console.error("Unexpected error:", err);
  }
}